module.exports = function() {
  return new Worker(__webpack_public_path__ + "909c50093a01fedf8c2b.worker.js");
};